import React from 'react';

function InvalidRoute() {
  return (<div>Error: 404 Not Found. The requested URL was not found on this server.</div>);
}

export default InvalidRoute;
